<template>
<a class="m-report__bread-crumb" href="/analytics/mortgage/">Ипотека</a>
<h1 class="m-report__heading-title">{{ title }}</h1>
<div class="m-report-wrapper">
    <p class="m-report__public-date">Дата публикации: {{ date }}</p>
    <div class="m-report__share">
        <button-share></button-share>
        <a class="m-report__btn m-report__btn--primary m-report__btn--icon-left" :href="report_file.src"
            :title="report_file.original_name" :download="report_file.original_name">
            <svg class="m-report__btn-svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M12 1.5C12.5523 1.5 13 1.94772 13 2.5L13 12.1771L15.8271 9.3508C16.2177 8.96033 16.8508 8.96041 17.2413 9.35099C17.6318 9.74157 17.6317 10.3747 17.2411 10.7652L12.707 15.2981C12.3165 15.6885 11.6835 15.6885 11.293 15.2981L6.75889 10.7652C6.36832 10.3747 6.36824 9.74157 6.75871 9.35099C7.14918 8.96041 7.78235 8.96033 8.17292 9.3508L11 12.1771L11 2.5C11 1.94772 11.4477 1.5 12 1.5ZM3 15C3.55228 15 4 15.4477 4 16V21L20 21L20 16C20 15.4477 20.4477 15 21 15C21.5523 15 22 15.4477 22 16L22 21.25C22 21.7436 21.7853 22.1974 21.4361 22.5175C21.0898 22.8349 20.6373 23 20.1818 23L3.81818 23C3.36269 23 2.91023 22.8349 2.56392 22.5175C2.21469 22.1974 2 21.7436 2 21.25L2 16C2 15.4477 2.44772 15 3 15Z"
                    fill="white" />
            </svg>
            <span class="m-report__btn-txt">
                Скачать весь отчет
            </span>
        </a>
    </div>
</div>
</template>

<script>
import ButtonShare from '../../../ui/ButtonShare'
export default {
    name: 'Heading',
    components: {ButtonShare},
    props: {
        title: {
            type: String,
        },
        date: {
            type: String
        },
        report_file: {
            type: Object,
        },
    }

}
</script>